/* LSF • product-link hash scrubber
   - Strips tab hashes like #tab-… / #tab-template--… / …video_hero_tabs… from any /products/ link
   - Cleans existing anchors, anchors injected later, and intercepts navigation (pointerdown/click/auxclick)
   - Preserves new-tab behavior (cmd/ctrl/middle click or target="_blank")
*/
(() => {
  const HASH_RX = /(^#tab-|^#tab-template--|video_hero_tabs)/i;

  // Clean all product anchors under a root node
  function cleanProducts(root = document) {
    root.querySelectorAll('a[href*="/products/"]').forEach(a => {
      try {
        const u = new URL(a.href, location.origin);
        if (u.hash && HASH_RX.test(u.hash)) {
          u.hash = '';
          a.href = u.toString();
        }
      } catch (_) { /* ignore malformed urls */ }
    });
  }

  // Initial pass
  cleanProducts();

  // Keep things clean for dynamically added links (apps/sections)
  const mo = new MutationObserver(ms => {
    for (const m of ms) {
      m.addedNodes.forEach(n => { if (n.nodeType === 1) cleanProducts(n); });
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', () => cleanProducts());

  // Intercept navigation early so no script can append the hash later
  function navGuard(e) {
    const a = e.target?.closest?.('a[href*="/products/"]');
    if (!a) return;

    try {
      const u = new URL(a.href, location.origin);
      if (!u.hash || !HASH_RX.test(u.hash)) return;

      const openNew = e.metaKey || e.ctrlKey || e.button === 1 || a.target === '_blank';

      e.preventDefault();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      u.hash = '';
      if (openNew) {
        window.open(u.toString(), '_blank', 'noopener');
      } else {
        location.href = u.toString();
      }
    } catch (_) { /* noop */ }
  }

  // Capture phase = run before other listeners; include pointerdown for early navigations
  document.addEventListener('pointerdown', navGuard, true);
  document.addEventListener('click',       navGuard, true);
  document.addEventListener('auxclick',    navGuard, true);
})();
